// extracted by mini-css-extract-plugin
export var deleteIcon = "_tp-5";
export var deleteOption = "_tp-3";
export var divider = "_tp-2";
export var downloadIcon = "_tp-4";
export var drawer = "_tp-0";
export var drawerFooter = "_tp-6";
export var drawerOpen = "_tp-1";
export var highlighted = "_tp-7";
export var lighterHighlight = "_tp-8";